import { ReactNode } from 'react';
import { AnswerDataType } from 'data/types';
import AnswerCard3 from 'components/AnswerCard/AnswerCard3';

const Layout = ({
  children,
  answer,
}: {
  children: ReactNode;
  answer: AnswerDataType;
}) => {
  const question = answer?.title;
  return (
    <div>
      {children}

      {answer && (
        <div className="container my-10 space-y-3">
          {question && (
            <h2 className="text-lg sm:text-2xl font-semibold pl-10">
              {question}
            </h2>
          )}
          <div className="max-w-screen-lg">
            <AnswerCard3 answer={answer} key={answer.id} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Layout;
